module.exports = {
	extends: [
		'/',
		'base',
		'mediaManagement',
		'upload',
		'plupload',
		'plupload'
	],

	config: {
		mode: 'subscriberImporter',
		secureRoute: '/~/subscriberImporter',
		pluploaderConfig: {
			multi_selection: false,
			url: '/LTR/~/subscriberImporter',
			filters: {
				mime_types: [
					{
						title: 'Files',
						extensions: 'csv,xlsx'
					}
				]
			}
		}
	},

	methods: {
		prepare(){
			let importer
			this.closest('templates_newsletter_subscribers_importer', c => importer = c)
			if(importer) {
				const importParams = (importer.model || {}).importParams || {}
				this.config.pluploaderConfig.multipart_params = {
					...(this.config.pluploaderConfig.multipart_params || {}),
					...importParams,
					propertyChanges: JSON.stringify(importParams.propertyChanges || {}),
				}
			}
		},

		beforeChunkUpload: function(file, post, a, b){
			// last chunk of upload file
			if((post || {}).chunk === (((post || {}).chunks || 0) - 1)){
				var statusController;
				if((statusController = getComponent('statusController'))){
					statusController.showStatus('status.progress.import');
				}
			}
		},

		uploadComplete: function(){
			let statusController
			if((statusController = getComponent('statusController'))){
				statusController.removeStatus()
			}

			const uploadResponse = this.model.lastResponse || {}

			let importer
			this.closest('templates_newsletter_subscribers_importer', c => importer = c)
			if(importer){
				importer.updateImportResponse('upload', uploadResponse)
			}
		}
	}
}